export default __webpack_public_path__ + "static/media/gallery2.55aa4639.jpg";